import './basepage-custom.scss';
import $ from 'jquery';
import 'brandhub-embxp-frontend/src/components/basepage/_reveal-it';
import 'brandhub-embxp-frontend/src/common/js/lazyload/lazyload';
import browserDetect from 'brandhub-embxp-frontend/src/common/js/browserdetect/browserdetect';
import 'popper.js';
import 'bootstrap/dist/js/bootstrap';

window.$ = $;
browserDetect.addGlobalClasses();



// WEBPACK FOOTER //
// ./src/components/basepage/basepage.js